import React from 'react';

import NavMenuItem from './NavMenuItem';

class NavMenu extends React.Component {

    constructor(props) {
        super();

        this.state = {
            viewport: {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            }
        };

        this.updateDimensions = this.updateDimensions.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    updateDimensions(event) {
        this.setState({
            viewport: {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            }
        });
    }

    render() {

        var menuStyle = {
            marginTop: 20,
            display: "flex",
            justifyContent: "flex-start",
            flexWrap: "wrap"
        }

        var viewWidth = this.state.viewport.width;
        var menuItemWidth = "auto";
        if(viewWidth < 410) {
            menuItemWidth = "100%";
        } else if(viewWidth < 500) {
            menuItemWidth = "50%";
        } else if(viewWidth < 641) {
            menuItemWidth = "33%";
        }

        return (
            <div style={menuStyle}>
                <NavMenuItem text="[ Home ]" itemwidth={menuItemWidth} pushTo="/"/>
                <NavMenuItem text="[ Services ]" itemwidth={menuItemWidth} pushTo="/services/fulllist"/>
                <NavMenuItem text="[ CV / Resumé ]" itemwidth={menuItemWidth} pushTo="/resume"/>
                <NavMenuItem text="[ Project History ]" itemwidth={menuItemWidth} pushTo="/projecthistory"/>
                <NavMenuItem text="[ My Apps ]" itemwidth={menuItemWidth} pushTo="/myapps"/>
                <NavMenuItem text="[ Contact Me ]" itemwidth={menuItemWidth} pushTo="/contact"/>
            </div>
        );
    }
}

export default NavMenu



// WEBPACK FOOTER //
// src/NavMenu.js